export default "__VITE_ASSET__fY$Njj$c__"